<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">邮箱配置</div>
          <div class="card-body">
            <Alert show-icon type="warning">QQ邮箱需先开通SMTP，且密码要填写QQ邮箱独立授权码，设置完成请发件测试是否正常，以免业务报错</Alert>
            <Divider />

            <Form ref="create" :model="formValidate" :label-width="110">
              <FormItem label="SMTP服务器" prop="email_smtp">
                <Input v-model="formValidate.email_smtp" placeholder="请输入SMTP服务器"></Input>
              </FormItem>
              <FormItem label="SMTP端口" prop="email_port">
                <Input v-model="formValidate.email_port" placeholder="请输入SMTP端口"></Input>
              </FormItem>
              <FormItem label="邮箱账号" prop="email_usr">
                <Input v-model="formValidate.email_usr" placeholder="请输入邮箱账号"></Input>
              </FormItem>
              <FormItem label="邮箱密码" prop="email_pwd">
                <Input v-model="formValidate.email_pwd" placeholder="请输入邮箱密码"></Input>
              </FormItem>

              <Divider />
              <FormItem label="收件邮箱" prop="admin_mailbox">
                <Input v-model="formValidate.admin_mailbox" placeholder="请输入管理员收件邮箱 (用于接收通知)"></Input>
              </FormItem>

              <FormItem>
                <Button type="primary" @click="editSave" :loading="creating">{{
                  text
                }}</Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getSystem,
    putSystem,
    sendEmail
  } from "@/api/admin";
  export default {
    data() {
      return {
        creating: false,
        text: "保存",
        formValidate: {},


      };
    },
    created() {
      this._getData();
    },

    methods: {
      // 获取列表
      _getData() {
        getSystem("email").then((res) => {
          this.formValidate = res.data;
        });
      },
      // 保存修改
      editSave() {
        this.creating = true;
        putSystem({
          createData: this.formValidate,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
            this.text = "正在发送测试邮件";
            this.emailTest();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
            this.creating = false;
          }
        });

      },
      // 发送测试
      emailTest() {
        sendEmail()
          .then((res) => {
            if (res.code == 200) {
              this.$Message.success({
                background: true,
                content: "测试邮件发送成功",
              });
            } else {
              this.$Message.error({
                background: true,
                content: res.msg,
              });
            }
            this.creating = false;
            this.text = "保存";
          })
          .catch((err) => {
            this.$Message.error({
              background: true,
              content: err,
            });
            this.creating = false;
            this.text = "保存";
          });
      },
    },
  };
</script>

<style lang="less" scoped>
 
</style>